import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { flow } from 'lodash/fp';
import { ButtonGroup } from 'ui';
import { sortByPosition, mapWithIndexes as map } from 'utils/fp';
import sectionActions from 'actions/editor';
import Section from './section';
import NewSectionDropdown from './NewSectionDropdown';

class EditorSections extends Component {
  constructor(props) {
    super(props);
    this.state = { sticky: false, disableOutline: false };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.handleResize();
    document.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  get addSectionTitle() {
    if (this.props.hasElearningLessonSection)
      return `+ ${t('lessons.editor.sections.new_section')}`;
    if (this.props.isCommenting) return '+';
    return t('lessons.editor.sections.new_section');
  }

  get hideNewSectionButton() {
    return (
      (this.props.isCommenting && this.props.hasElearningLessonSection) ||
      this.props.templateActive
    );
  }

  handleScroll(e) {
    requestAnimationFrame(() => {
      const { parentNode } = this.container;
      const parentRect = parentNode.getBoundingClientRect();
      const containerRect = this.container.getBoundingClientRect();

      if (containerRect.height < parentRect.height) {
        this.setState({
          sticky: parentNode.offsetTop <= window.pageYOffset,
          stickyBottom: containerRect.height >= parentRect.bottom,
          containerStyle: { width: `${parentRect.width}px` },
        });
      } else {
        this.setState({ sticky: false, stickyBottom: false });
      }
    });
  }

  handleResize() {
    requestAnimationFrame(() => {
      const { width } = this.container.parentNode.getBoundingClientRect();
      this.setState({ containerStyle: { width: `${width}px` } });
    });
  }

  handleClick(e) {
    this.setState({ disableOutline: true });
    this.props.addSection('Paragraph');
  }

  renderSection(section, i) {
    return <Section {...section} key={section.id} index={i} />;
  }

  renderSections() {
    return flow(map(this.renderSection), sortByPosition)(this.props.sections);
  }

  render() {
    return (
      <div
        ref={n => {
          this.container = n;
        }}
        style={this.state.containerStyle}
        className={classNames('EditorSections', {
          sticky: this.state.sticky,
          'sticky--bottom': this.state.stickyBottom,
        })}
      >
        <ButtonGroup
          className={classNames('EditorSections-header', {
            hidden: this.hideNewSectionButton,
          })}
        >
          {!this.hideNewSectionButton && (
            <button
              type="button"
              onClick={this.handleClick}
              onBlur={() => this.setState({ disableOutline: false })}
              className={classNames(
                'NewButton NewButton--dark NewButton--center',
                {
                  hasElearning: this.props.hasElearningLessonSection,
                  disableOutline: this.state.disableOutline,
                },
                'trk_button_readiness_new-section',
              )}
              children={this.addSectionTitle}
            />
          )}
          {this.props.hasElearningLessonSection && !this.props.isTemplate && (
            <NewSectionDropdown
              addSection={this.props.addSection}
              containerStyle={this.state.containerStyle}
              sticky={this.state.sticky}
              stickyBottom={this.state.stickyBottom}
              isCommenting={this.props.isCommenting}
            />
          )}
        </ButtonGroup>
        <div
          className="EditorSections-list trk_container_readiness_section-list"
          children={this.renderSections()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  sections: state.editor.sections,
  isCommenting: state.editor.commentary.visible,
  hasElearningLessonSection: state.meta.features.elearning_lesson_section,
  isTemplate: state.editor.isTemplate,
  templateActive: state.editor.templateActive,
});

const mapDispatchToProps = dispatch => ({
  addSection(elementType) {
    dispatch(sectionActions.create(elementType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorSections);
